declare namespace $ {

	export class $mol_icon_division extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=division.view.tree.d.ts.map